import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LibConfettiComponent } from './confetti.component';



@NgModule({
  declarations: [
    LibConfettiComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    LibConfettiComponent
  ]
})
export class LibConfettiModule { }
